import { type ITenant } from 'src/common/interfaces/Tenant';
import { type IUser } from 'src/common/interfaces/User';
import {
	OBSERVABILITY_EMPTY_VALUE,
	OBSERVABILITY_UNKNOWN_VALUE
} from 'src/common/services/ObservabilityContextHelper.constants';
import {
	type TObservabilityUserTenantContext,
	type TObservabilityUserTenantMetadata
} from 'src/common/services/ObservabilityContextHelper.types';

const buildUserName = (userInfo?: IUser): string =>
	`${userInfo?.name ?? OBSERVABILITY_EMPTY_VALUE} ${
		userInfo?.surname ?? OBSERVABILITY_EMPTY_VALUE
	}`.trim() || OBSERVABILITY_UNKNOWN_VALUE;

const buildUserMetadata = (
	userInfo?: IUser
): Pick<TObservabilityUserTenantMetadata, 'role' | 'roleType'> => ({
	role: userInfo?.role?.name || OBSERVABILITY_EMPTY_VALUE,
	roleType: userInfo?.role?.type || OBSERVABILITY_EMPTY_VALUE
});

const buildTenantMetadata = (
	tenantInfo?: ITenant
): Omit<TObservabilityUserTenantMetadata, 'role' | 'roleType'> => ({
	accountId: tenantInfo?.id || OBSERVABILITY_UNKNOWN_VALUE,
	accountPlan: tenantInfo?.accountPlan || OBSERVABILITY_EMPTY_VALUE,
	companyName: tenantInfo?.companyName || OBSERVABILITY_EMPTY_VALUE,
	tenant_id: tenantInfo?.id || OBSERVABILITY_EMPTY_VALUE,
	tenant_name: tenantInfo?.name || OBSERVABILITY_EMPTY_VALUE
});

export const buildObservabilityUserTenantContext = (
	userInfo?: IUser,
	tenantInfo?: ITenant
): TObservabilityUserTenantContext => ({
	userId: userInfo?.id || OBSERVABILITY_UNKNOWN_VALUE,
	userName: buildUserName(userInfo),
	userEmail: userInfo?.email || OBSERVABILITY_UNKNOWN_VALUE,
	userMetadata: {
		...buildTenantMetadata(tenantInfo),
		...buildUserMetadata(userInfo)
	}
});
